<template>
	<div class="bf">
		<div class="pt20 pb20 plr20 bor_b flex_items flex_between" :key="index"
			@click="$router.push({path:'/' + (t == 0 ? 'sign' : t == 1 ? 'userLeaveList' : t == 2 ? 'attlist' : 'userScoreList'),query:{id:item.id}})" v-for="(item,index) in list">
			<span>{{item.name}}</span>
			<van-icon name="arrow" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				t: 0, //0-签到 1-请假 2-出勤记录 3-积分记录
			}
		},
		methods: {
			getList() {
				this.api.userPro().then(res => {
					this.list = res.data;
				})
			}
		},
		created() {
			this.t = this.$route.query.t;
			
			this.getList()
		}
	}
</script>

<style>
</style>
